/**
 * The application name, for code inside venn-utils. venn-ui-kit's getAppTitle cannot be used here: it would
 * make venn-utils and venn-ui-kit import each other. getTextThemeProvider.test.ts keeps the two in step.
 */
export const getAppTitleSimplifiedUtil = (): string => 'Risk Pro';
